import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "app-electricity",
  "use": "app-electricity-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol viewBox=\"0 0 50 50\" id=\"app-electricity\"><defs><style>#app-electricity .cls-1{fill:#ffb93d;}#app-electricity .cls-2{fill:#fff;}</style></defs><title>资源 45</title><g id=\"app-electricity_图层_2\" data-name=\"图层 2\"><g id=\"app-electricity_图层_1-2\" data-name=\"图层 1\"><rect class=\"cls-1\" width=\"50\" height=\"50\" /><path class=\"cls-2\" d=\"M35.13,9.81H14.87A2.17,2.17,0,0,0,12.7,12V38a2.17,2.17,0,0,0,2.17,2.17H35.13A2.17,2.17,0,0,0,37.3,38V12A2.17,2.17,0,0,0,35.13,9.81Zm-13.65,9.6,4.78-4.69a.25.25,0,0,1,.35,0,.24.24,0,0,1,.07.16.25.25,0,0,1,0,.1l-.82,3.46h2.44a.26.26,0,0,1,.16.05l.06,0h0a.24.24,0,0,1,0,.34l-4.78,4.69a.25.25,0,0,1-.18.07.25.25,0,0,1-.18-.07.24.24,0,0,1-.06-.25.2.2,0,0,1,0-.06l.84-3.41H21.63a.25.25,0,0,1-.23-.26A.24.24,0,0,1,21.48,19.41ZM32.81,33.86a1.09,1.09,0,0,1-.94.54H18.13a1.09,1.09,0,1,1,0-2.17H31.87a1.09,1.09,0,0,1,.94,1.63Zm0-4.34a1.09,1.09,0,0,1-.94.54H18.13a1.09,1.09,0,1,1,0-2.17H31.87a1.09,1.09,0,0,1,.94,1.63Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/app-electricity.svg
// module id = Wi3d
// module chunks = 264